/**
 * Store Lot Client Status
 */
export default {
    state: {
        status: [],
    },

    mutations: {
        setLotClientStatus: function (state, status) {
            state.status = status
        }
    },

    getters: {
        optionsLotClientStatuts: state => {
            return [{label: '', value: null}].concat(
                state.status.map((status) => ({
                    label: status.nom,
                    value: status.id,
                }))
            )
        },
        getLotClientStatutName: state => id =>  {
            const result = state.status.find((status) => status.id === parseInt(id))
            return result ? result.nom : 'Non défini'
        }
    }
}
